import * as React from "react"
import Links from "../common/links"

export default function CardListWithIcon({ data }) {
  const content = data

  return (
    <div className="">
      {content.heading && (
        <h1 className="mb-8 text-center heading section-h md:mb-14">
          {content.heading}
        </h1>
      )}

      {content.cardList && content.cardListStyle === "style_1" && (
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3 lg:gap-10 2xl:gap-16">
          {content.cardList.map((item, i) => {
            return (
              <div key={item.title} className="fadein-up">
                <div className="card-list-item rounded-[48px] h-full px-6 md:px-7 py-5 2xl:px-11 2xl:py-9 text-dark ">
                  <div>
                    <img
                      src={item.icon.sourceUrl}
                      alt="icon"
                      className="w-20"
                    />
                  </div>
                  <h4 className="text-lg mt-9 heading" dangerouslySetInnerHTML={{__html: item.title}}></h4>
                  <div className="mt-3 text-sm">{item.excerpt}</div>
                </div>
              </div>
            )
          })}
        </div>
      )}

      {content.cardList && content.cardListStyle === "style_2" && (
        <div className="grid gap-6 text-center md:grid-cols-2 lg:grid-cols-4">
          {content.cardList.map((item, i) => {
            return (
              <div key={item.title} className="fadein-up">
                <div className="card-list-item rounded-[48px] h-full px-7 py-5 lg:px-11 lg:py-9 text-dark ">
                  <div className="block">
                    <img
                      src={item.icon.sourceUrl}
                      alt="icon"
                      className="w-16 mx-auto"
                    />
                  </div>
                  <h4 className="text-lg lg:text-[22px] mt-9 heading">
                    {item.title}
                  </h4>
                  <div className="mt-3 text-sm">{item.excerpt}</div>
                </div>
              </div>
            )
          })}
        </div>
      )}

      {content.excerpt && (
        <div className="mt-8 md:mt-12">
          <div
            className="text-sm text-center md:text-base"
            dangerouslySetInnerHTML={{ __html: content.excerpt }}
          ></div>
        </div>
      )}

      {content.links && (
        <div className="flex justify-center mt-6">
          <Links data={content.links} />
        </div>
      )}
    </div>
  )
}
